import { render, staticRenderFns } from "./EspacoFisico.vue?vue&type=template&id=1cd25370&"
import script from "./EspacoFisico.vue?vue&type=script&lang=js&"
export * from "./EspacoFisico.vue?vue&type=script&lang=js&"
import style0 from "./EspacoFisico.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
